export function isMobile() {
    if (typeof window !== 'undefined') {
        return Math.min(window.screen.width, window.screen.height) < 768;
    } else {
        return false;
    }
}